export type TikTokTtq = {
  load: (pixelId: string) => void;
  page: () => void;
  track?: (event: string, payload?: Record<string, unknown>) => void;
  instance?: (pixelId: string) => TikTokTtq;
};

export const TIKTOK_PIXEL_SCRIPT_SRC =
  'https://analytics.tiktok.com/i18n/pixel/events.js';
